import axiosInstance from '@/lib/axiosInstance';
import { AccessCode } from '@/model/AccessCode.model';
import { EdetAccessCodeGroup } from '@/model/AccessCodeGroup.model';

export const getAccessCodeById = async (id?: string) => {
  const { data } = await axiosInstance.get(`/access-codes/${id}`);
  return AccessCode.fromJson(data);
};

export const getEdetAccessCodeGroups = async (): Promise<EdetAccessCodeGroup[]> => {
  const { data } = await axiosInstance.get('/edet/admin/access-code-groups');
  return EdetAccessCodeGroup.fromJsonArray(data);
};

export const getEdetAccessCodeGroupById = async (id: string): Promise<EdetAccessCodeGroup> => {
  const { data } = await axiosInstance.get(`/edet/admin/access-code-groups/${id}`);
  return EdetAccessCodeGroup.fromJson(data);
};

export interface CreateEdetAccessCodeRequest {
  prefix: string;
  accessCodeGroup: string;
  expiresAt: string;
  users: Array<{
    firstName: string;
    lastName: string;
    externalId: string;
  }>;
}

export const createEdetAccessCodes = async (request: CreateEdetAccessCodeRequest): Promise<void> => {
  await axiosInstance.post('/edet/admin/access-codes', request);
};
